<div class="filter-wrapper w-100 mb-4">
  <mat-accordion class="filter-accordion">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>filter_alt</mat-icon>
          Filtri
        </mat-panel-title>
        <mat-panel-description> </mat-panel-description>
      </mat-expansion-panel-header>
      <div [formGroup]="searchFilter" class="w-100" class="row">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'common.search' | translate }}</mat-label>
            <input formControlName="term" matInput type="text" #MapsAutocomplete />
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearDefaultSearchFilter()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'map.sidebar.fibra.form.stato' | translate }}</mat-label>
            <mat-select formControlName="status">
              <mat-option *ngFor="let stato of statoFibra" [value]="stato.value">
                {{ stato.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <div>
    <button
      mat-mini-fab
      color="accent"
      class="mx-1"
      [matMenuTriggerFor]="menu"
      [matTooltip]="'map.map_table.export' | translate"
      matTooltipPosition="above"
    >
      <mat-icon>download</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="onExport('html')">
        {{ 'map.map_table.export_html' | translate }}
      </button>
      <button mat-menu-item (click)="onExport('csv')">
        {{ 'map.map_table.export_csv' | translate }}
      </button>
    </mat-menu>
  </div>
</div>

<div class="map-table-content">
  <div class="my-3 legend-box">
    <div class="d-flex align-items-center mx-1">
      <mat-icon class="status-color--free">check_circle_outline</mat-icon>
      <span class="ms-1">{{ 'map.sidebar.fibra.status.free' | translate }}</span>
    </div>

    <div class="d-flex align-items-center mx-1">
      <mat-icon class="status-color--booked">hourglass_empty</mat-icon>
      <span class="ms-1">{{ 'map.sidebar.fibra.status.booked' | translate }}</span>
    </div>

    <div class="d-flex align-items-center mx-1">
      <mat-icon class="status-color--unavailable">do_disturb</mat-icon>
      <span class="ms-1">{{ 'map.sidebar.fibra.status.unavailable' | translate }}</span>
    </div>

    <div class="d-flex align-items-center mx-1">
      <mat-icon class="status-color--outOfOrder">info_outline</mat-icon>
      <span class="ms-1">{{ 'map.sidebar.fibra.status.out_of_order' | translate }}</span>
    </div>

    <div class="d-flex align-items-center mx-1">
      <mat-icon class="status-color--bookedLD">hourglass_top</mat-icon>
      <span class="ms-1">{{ 'map.sidebar.fibra.status.booked_ld' | translate }}</span>
    </div>

    <div class="d-flex align-items-center mx-1">
      <mat-icon class="status-color--toCheck">checklist</mat-icon>
      <span class="ms-1">{{ 'map.sidebar.fibra.status.to_check' | translate }}</span>
    </div>

    <div class="d-flex align-items-center mx-1">
      <mat-icon class="status-color--unusable">report_gmailerrorred</mat-icon>
      <span class="ms-1">{{ 'map.sidebar.fibra.status.unusable' | translate }}</span>
    </div>
  </div>
  <mtx-grid
    #grid
    [data]="dataGrid"
    [columns]="columnsGrid"
    [showColumnMenuHeader]="false"
    [noResultText]="'common.no_result' | translate"
    [showFirstLastButtons]="false"
    [rowStriped]="true"
    [showPaginator]="true"
    [emptyValuePlaceholder]="'-'"
    [pageSize]="pageSize"
    [pageOnFront]="false"
    [pageIndex]="currentPageIndex"
    [pageSizeOptions]="pageSizeOptions"
    [length]="totalCount"
    [sortOnFront]="false"
    [sortDisabled]="false"
    sortStart="asc"
    (sortChange)="onSortChange($event)"
    (page)="onPageChange($event)"
  >
  </mtx-grid>

  <ng-template #actionsTemplate let-row>
    <div class="d-flex align-items-center">
      <button
        mat-icon-button
        (click)="openHistoryModal(row)"
        [matTooltip]="'map.sidebar.fibra.table.history' | translate"
        matTooltipPosition="below"
      >
        <mat-icon>history</mat-icon>
      </button>

      <button
        mat-icon-button
        *ngIf="userCanEdit"
        (click)="openFibraModal(row.id)"
        [matTooltip]="'common.modify' | translate"
        matTooltipPosition="below"
      >
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </ng-template>

  <ng-template #statusColTemplate let-row>
    <!--
            LIBERA
            OCCUPATA
            PRENOTATA
            INUTILIZZABILE
            GUASTA
            DA VERIFICARE
            BOOKED LD
        -->
    <ng-container [ngSwitch]="row.stato">
      <ng-container *ngSwitchCase="fiberStatusEnum.free">
        <mat-icon
          class="status-color--free"
          [matTooltip]="'map.sidebar.fibra.status.free' | translate"
          matTooltipPosition="below"
          >check_circle_outline</mat-icon
        >
      </ng-container>
      <ng-container *ngSwitchCase="fiberStatusEnum.booked">
        <mat-icon
          class="status-color--booked"
          [matTooltip]="'map.sidebar.fibra.status.booked' | translate"
          matTooltipPosition="below"
          >hourglass_empty</mat-icon
        >
      </ng-container>
      <ng-container *ngSwitchCase="fiberStatusEnum.unavailable">
        <mat-icon
          class="status-color--unavailable"
          [matTooltip]="'map.sidebar.fibra.status.unavailable' | translate"
          matTooltipPosition="below"
          >do_disturb</mat-icon
        >
      </ng-container>
      <ng-container *ngSwitchCase="fiberStatusEnum.outOfOrder">
        <mat-icon
          class="status-color--outOfOrder"
          [matTooltip]="'map.sidebar.fibra.status.out_of_order' | translate"
          matTooltipPosition="below"
          >info_outline</mat-icon
        >
      </ng-container>
      <!--  -->
      <ng-container *ngSwitchCase="fiberStatusEnum.bookedLD">
        <mat-icon
          class="status-color--bookedLD"
          [matTooltip]="'map.sidebar.fibra.status.booked_ld' | translate"
          matTooltipPosition="below"
          >hourglass_top</mat-icon
        >
      </ng-container>

      <ng-container *ngSwitchCase="fiberStatusEnum.toCheck">
        <mat-icon
          class="status-color--toCheck"
          [matTooltip]="'map.sidebar.fibra.status.to_check' | translate"
          matTooltipPosition="below"
          >checklist</mat-icon
        >
      </ng-container>

      <ng-container *ngSwitchCase="fiberStatusEnum.unusable">
        <mat-icon
          class="status-color--unusable"
          [matTooltip]="'map.sidebar.fibra.status.unusable' | translate"
          matTooltipPosition="below"
          >report_gmailerrorred</mat-icon
        >
      </ng-container>

      <ng-container *ngSwitchDefault>
        <p>{{ row.stato }}</p>
      </ng-container>
    </ng-container>
    <!-- <button mat-icon-button color="primary" (click)="centerMapMarker(row)">
          <mat-icon>place</mat-icon>
        </button> -->
  </ng-template>
</div>
